import { render } from "./PaymentReceiptBanner.vue?vue&type=template&id=9b7d563e&scoped=true"
import script from "./PaymentReceiptBanner.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptBanner.vue?vue&type=script&lang=js"

import "./PaymentReceiptBanner.vue?vue&type=style&index=0&id=9b7d563e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b7d563e"]])

export default __exports__